<app-order-status [status]="params.data.Status | titlecase" *ngIf="params.data.Account !== 'My Channel'"></app-order-status>

<mat-select [(ngModel)]="params.data.Status" *ngIf="params.data.Account === 'My Channel'"
  (ngModelChange)="statusChanged($event)">
  <mat-select-trigger>
    <app-order-status [status]="params.data.Status  | titlecase"></app-order-status>
  </mat-select-trigger>
  <mat-option *ngFor="let status of statusList" [value]="status">
    <app-order-status [status]="status"></app-order-status>
  </mat-option>
</mat-select>